<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table
      noDataText="Nenhum Cancelamento Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      :max-items="itemsPerPage"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES -----------
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="inativar">
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="reativar">
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="perfis.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <------------ END MENU DE AÇÕES ------------>

          <!------------ START ADD NOVO Perfil ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="novoCancelamento()"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Novo Processo de Cancelamento / Retenção</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Perfil ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{ itens.length }} de {{ qtdTotal }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="Nome">Cancelamento</vs-th>
        <vs-th sort-key="Nome">Veículo</vs-th>
        <vs-th sort-key="Nome">Beneficiário</vs-th>
        <vs-th sort-key="Nome">Responsável</vs-th>
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.id_cancelamento }}</p>
              <p class="product-category">{{ formataData(tr.createdAt) }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.dadosJson.veiculo.placa }}</p>
              <p class="product-category">{{ tr.dadosJson.veiculo.marca }}</p>
              <p class="product-category">{{ tr.dadosJson.veiculo.modelo }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.dadosJson.associado.nome }}</p>
              <p class="product-category">{{ tr.dadosJson.associado.email }}</p>
              <p class="product-category">
                {{ tr.dadosJson.associado.celular }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.responsavel }}</p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.id_status)"
                class="product-order-status"
                >{{ tr.nomeStatus }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <div class="vx-col" v-if="tr.id_status == 2">
                  <vs-button
                    v-tooltip="'Resumo do Cancelamento'"
                    radius
                    color="dark"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-search"
                    class="d-inline"
                    @click="opemModal(tr.id_cancelamento)"
                  ></vs-button>
                </div>
                <div
                  class="vx-col"
                  v-if="
                    tr.id_status != 1 &&
                    $can($actionsDefault.Escrita, subjectPermission)
                  "
                >
                  <vs-button
                    v-tooltip="'Detalhes do Cancelamento'"
                    radius
                    color="warning"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-book-open"
                    class="d-inline"
                    @click="redirecionaDetalhe(tr.id_cancelamento)"
                  ></vs-button>
                </div>
                <div
                  class="vx-col"
                  v-if="
                    (tr.id_status == 1 || tr.id_status == 5) &&
                    $can($actionsDefault.Escrita, subjectPermission)
                  "
                >
                  <vs-button
                    v-tooltip="'Editar Cancelamento'"
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline"
                    @click="redirecionaEdicao(tr.id_cancelamento)"
                  ></vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination :total="qtdPaginas" v-model="paginaAtual"></vs-pagination>
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO Perfil ------------>
    <vs-popup
      :title="'Status Processo Cancelamento'"
      @close="popupActive = false"
      :active.sync="popupActive"
    >
      <div class="con-exemple-prompt" v-if="modalSelecionado">
        <vs-row>
          <vs-col
            v-if="modalSelecionado.isRetido != true"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            vs-sm="6"
            vs-xs="12"
          >
            <vs-card class="p-1"
              ><div slot="header">
                <h6>Boletos Baixados</h6>
              </div>
              <vs-chip
                v-if="modalSelecionado.boletoBaixado == true"
                color="success"
                class="product-order-status"
                >Sim</vs-chip
              >
              <div v-else>
                <vs-chip
                  color="danger"
                  class="product-order-status d-block mb-3"
                  >Não</vs-chip
                >
                <vs-button
                  @click="buscaBoletosNovamente(modalSelecionado)"
                  color="success"
                  class="mt-3"
                  icon-pack="feather"
                  icon="icon-search"
                >
                  <span>Consultar</span>
                </vs-button>
              </div>
            </vs-card>
          </vs-col>
          <vs-col
            v-if="modalSelecionado.isRetido != true"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            vs-sm="6"
            vs-xs="12"
          >
            <vs-card class="p-1"
              ><div slot="header">
                <h6>Rastreador Removido</h6>
              </div>
              <vs-chip
                v-if="modalSelecionado.rastreadoRemovido == true"
                color="success"
                class="product-order-status"
                >Sim</vs-chip
              >
              <div v-else>
                <vs-chip
                  color="danger"
                  class="product-order-status d-block mb-3"
                  >Não</vs-chip
                >
                <vs-button
                  @click="atualizarRastreador(modalSelecionado)"
                  color="success"
                  class="mt-3"
                  icon-pack="feather"
                  icon="icon-refresh-ccw"
                >
                  <span>Atualizar para Sim</span>
                </vs-button>
              </div>
            </vs-card>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            vs-sm="6"
            vs-xs="12"
          >
            <vs-card class="p-1"
              ><div slot="header">
                <h6>Assinatura de Termos</h6>
              </div>
              <vs-chip
                v-if="modalSelecionado.termosAssinados == true"
                color="success"
                class="product-order-status"
                >Sim</vs-chip
              >
              <div v-else>
                <vs-chip
                  color="danger"
                  class="product-order-status d-block mb-3"
                  >Não</vs-chip
                >
                <vs-button
                  @click="buscaTermos(modalSelecionado)"
                  color="success"
                  class="mt-3"
                  icon-pack="feather"
                  icon="icon-search"
                >
                  <span>Consultar</span>
                </vs-button>
              </div>
            </vs-card>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            vs-sm="6"
            vs-xs="12"
          >
            <vs-card class="p-1"
              ><div slot="header">
                <h6>Chamado Interno Baixado</h6>
              </div>
              <vs-chip
                v-if="modalSelecionado.chamadoInternoFinalizado == true"
                color="success"
                class="product-order-status"
                >Sim</vs-chip
              >
              <div v-else>
                <vs-chip
                  color="danger"
                  class="product-order-status d-block mb-3"
                  >Não</vs-chip
                >
                <vs-button
                  @click="buscaChamadoInterno(modalSelecionado)"
                  color="success"
                  class="mt-3"
                  icon-pack="feather"
                  icon="icon-search"
                >
                  <span>Consultar Status</span>
                </vs-button>

                <vs-button
                  @click="verChamado(modalSelecionado)"
                  color="success"
                  class="mt-3"
                  icon-pack="feather"
                  icon="icon-search"
                >
                  <span>Ver Chamado</span>
                </vs-button>
              </div>
            </vs-card>
          </vs-col> </vs-row
        ><vs-button
          v-if="
            modalSelecionado.isRetido ||
            ((!modalSelecionado.isRetido
              ? modalSelecionado.boletoBaixado == true
              : modalSelecionado.boletoBaixado == false) &&
              (!modalSelecionado.isRetido
                ? modalSelecionado.rastreadoRemovido == true
                : modalSelecionado.rastreadoRemovido == false) &&
              modalSelecionado.termosAssinados == true &&
              modalSelecionado.chamadoInternoFinalizado == true)
          "
          @click="finalizar(modalSelecionado)"
          color="dark"
          class="mb-2 my-5 ml-2"
        >
          <span>Finalizar</span>
        </vs-button>
      </div>
    </vs-popup>

    <!------------ END INFORMAÇÕES DO Perfil ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from './../Includes/SideBar';
import service from '../../services';
import downloadexcel from 'vue-json-excel';
import ModalInfo from '../../components/ModalInfo';
import moment from 'moment';

export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
  },
  props: ['filtro', 'realizaFiltro', 'vistoria', 'subjectPermission'],
  data() {
    return {
      idEmpresa: null,
      dadosSideBar: {},
      controllerGeral: 'Perfil',
      formSideBar: 'Perfil',
      entidade: 'Perfil',
      titleSideBar: 'Adicionar Perfil',
      popupActive: false,
      modalSelecionado: null,
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 25,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      isMounted: false,
      addNewDataSidebar: false,
    };
  },
  watch: {
    realizaFiltro: function (newValue, oldValue) {
      console.log(newValue);
      if (newValue == true) {
        // console.log(this.filtro);
        this.buscaDados();
        this.$emit('filtroOk', true);
      }
    },
    paginaAtual: function (newValue, oldValue) {
      // console.log(this.paginaAtual);
      this.buscaDados();
    },
    itemsPerPage: function (newValue, oldValue) {
      // console.log(this.itemsPerPage);
      this.buscaDados();
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    verChamado(modalSelecionado) {
      console.log(modalSelecionado);
      service
        .post('Cancelamento', 'BuscaChamadosInternos', {
          idCancelamento: modalSelecionado.id_cancelamento,
        })
        .then((res) => {
          console.log(res);
          if (res.data.chamado) {
            this.popupActive = false;
            this.$router.push(
              `editarChamadoInterno/${res.data.chamado.idChamado}`,
            );
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Nenhum Chamado Encontrado',
              color: 'danger',
            });
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });

      //
    },
    redirecionaEdicao(id) {
      this.$router.push(`EditarCancelamento/${id}`);
    },
    redirecionaDetalhe(id) {
      this.$router.push(`DetalheCancelamento/${id}`);
    },
    novoCancelamento() {
      this.$router.push('NovoCancelamento');
    },
    finalizar(item) {
      this.$vs.loading();
      service
        .post('Cancelamento', 'Finalizar', {
          idCancelamento: item.id_cancelamento,
          isRetido: item.isRetido,
        })
        .then((res) => {
          console.log(res);

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Processo de Cancelamento Finalizado com sucesso',
            color: 'success',
          });
          this.popupActive = false;
          this.buscaDados();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaChamadoInterno(item) {
      this.$vs.loading();
      service
        .post('Cancelamento', 'BuscaChamadosInternos', {
          idCancelamento: item.id_cancelamento,
        })
        .then((res) => {
          console.log(res);
          if (res.data.chamadoInternoFinalizado == true) {
            this.modalSelecionado.chamadoInternoFinalizado = true;
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Beneficiário ainda possui chamados(s) em aberto',
              color: 'danger',
            });
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaTermos(item) {
      this.$vs.loading();
      service
        .post('Cancelamento', 'BuscaTermos', {
          idCancelamento: item.id_cancelamento,
        })
        .then((res) => {
          console.log(res);
          if (res.data.termosAssinados == true) {
            this.modalSelecionado.termosAssinados = true;
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Beneficiário ainda possui termo(s) a serem assinados',
              color: 'danger',
            });
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    atualizarRastreador(item) {
      this.$vs.loading();
      service
        .post('Cancelamento', 'AtualizarRastreador', {
          idCancelamento: item.id_cancelamento,
        })
        .then((res) => {
          console.log(res);
          if (res.data.rastreadoRemovido == true) {
            this.modalSelecionado.rastreadoRemovido = true;
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Rastreador Removido',
              color: 'success',
            });
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaBoletosNovamente(item) {
      var codAssociado = item.dadosJson.associado.codigoAssociadoSGA;
      var token = item.dadosJson.dadosIntegracaoSGA.tokenUsuario;
      this.$vs.loading();
      service
        .post('Cancelamento', 'buscaBoletosAbertos', {
          codAssociado: codAssociado,
          token: token,
          idCancelamento: item.id_cancelamento,
        })
        .then((res) => {
          console.log(res);
          if (res.data.boletoBaixado == true) {
            this.modalSelecionado.boletoBaixado = true;
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text:
                'Ainda possui ' +
                res.data.boletos.length +
                ' boleto(s) em aberto',
              color: 'danger',
            });
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },

    buscaDados() {
      this.selected = [];
      this.$vs.loading();
      var objSend = {};

      if (this.filtro) {
        objSend = { ...this.filtro };
        objSend.dataInicial = moment(this.filtro.dataInicial).format(
          'YYYY-MM-DD',
        );
        objSend.dataFinal = moment(this.filtro.dataFinal).format('YYYY-MM-DD');
      }

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      console.log(objSend);

      service
        .post('Cancelamento', 'list', objSend)
        .then((res) => {
          this.itens = [];

          this.exibir = true;
          this.itens = [];
          console.log(res.data);
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.cancelamentos.forEach((element) => {
              if (element.dadosJson) {
                element.dadosJson = JSON.parse(element.dadosJson);
              } else {
                element.dadosJson = {};
              }
              this.itens.push(element);
            });
          }
          //this.itens = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      dados.idPerfil == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    opemModal(cod) {
      this.modalSelecionado = null;
      this.popupActive = true;
      var item = this.itens.find((x) => x.id_cancelamento == cod);
      this.modalSelecionado = item;
      console.log(this.modalSelecionado);
    },
    concluido() {
      this.buscaDados();
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    getStatusColor(data) {
      if (data == 1) return 'success';
      if (data == 2) return 'warning';
      if (data == 3) return 'warning';
      if (data == 4) return 'warning';
      if (data == 5) return 'primary';
      if (data == 6) return 'dark';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
